import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material//dialog';

@Component({
  selector: 'app-select-calendar-view',
  templateUrl: './select-calendar-view.component.html',
  styleUrls: ['./select-calendar-view.component.css']
})
export class SelectCalendarViewComponent implements OnInit {

  currentValue: string;
  options = [
    { title: "Listenansicht", desc: "Eine Listenansicht all Ihrer Termine in dieser Woche.", isSelected: false, value: "listWeek" },
    { title: "Wochenansicht", desc: "Eine Kalenderansicht der aktuellen Woche." , isSelected: false, value: "dayGridWeek" },
    { title: "Monatsansicht", desc: "Eine Listenansicht all Ihrer Termine in diesem Monat.", isSelected: false, value: "dayGridMonth" }
  ];

  constructor(
    private _dialogRef: MatDialogRef<SelectCalendarViewComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: string
  ) {
    this.currentValue = _data;
  }

  close(){
    this._dialogRef.close();
  }

  ngOnInit(): void {
  }

  selectOption(option: any){
    this.currentValue = option.value;
    this._dialogRef.close(option.value);
  }

}
